/**
 * **NOTE** The component in this file is a direct copy of the styles found at:
 * `src/modules/templateEditor/EditPush/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import { ChevronDownSmall } from 'ui/icons/navigation/ChevronDownSmall';
import { AndroidPlaceholder } from 'ui/icons/devices/AndroidPlaceholder';
import {
  ExpandedNotificationBubbleAndroid,
  ExpandedNotificationAndroidWrapper,
  ExpandedNotificationAttachmentAndroid,
  ExpandedNotificationAttachmentWrapperAndroid,
  ExpandedNotificationBubbleAndroidHeaderAndBodyWrapper,
  NotificationBubbleAndroidBody,
  NotificationBubbleAndroidBodyContent,
  NotificationBubbleAndroidHeaderTime,
  NotificationBubbleAndroidBodyContentMsgTitle,
  NotificationBubbleAndroidBodyContentMsgTxt,
  NotificationBubbleAndroidBodyContentMsg,
} from './ContentPreviewPush.styled';
import type { TemplateDiffContentPush } from '../../../types';

type ExpandedNotificationAndroidProps = TemplateDiffContentPush;

export const ExpandedNotificationAndroid = ({
  title,
  message,
  attachmentUrlAndroid,
}: ExpandedNotificationAndroidProps) => {
  return (
    <ExpandedNotificationAndroidWrapper>
      <ExpandedNotificationBubbleAndroid>
        <ExpandedNotificationBubbleAndroidHeaderAndBodyWrapper>
          <NotificationBubbleAndroidHeaderTime>
            <AndroidPlaceholder height={15} width={15} />
            <ChevronDownSmall />
          </NotificationBubbleAndroidHeaderTime>
          <NotificationBubbleAndroidBody>
            <NotificationBubbleAndroidBodyContent>
              <NotificationBubbleAndroidBodyContentMsgTitle>
                {title}
              </NotificationBubbleAndroidBodyContentMsgTitle>
              <NotificationBubbleAndroidBodyContentMsg>
                <NotificationBubbleAndroidBodyContentMsgTxt>
                  {message}
                </NotificationBubbleAndroidBodyContentMsgTxt>
              </NotificationBubbleAndroidBodyContentMsg>
            </NotificationBubbleAndroidBodyContent>
          </NotificationBubbleAndroidBody>
        </ExpandedNotificationBubbleAndroidHeaderAndBodyWrapper>
        {attachmentUrlAndroid && (
          <ExpandedNotificationAttachmentWrapperAndroid data-test="template-diff-push-preview-android-image">
            <ExpandedNotificationAttachmentAndroid
              src={attachmentUrlAndroid}
              alt="Android Push Image"
            />
          </ExpandedNotificationAttachmentWrapperAndroid>
        )}
      </ExpandedNotificationBubbleAndroid>
    </ExpandedNotificationAndroidWrapper>
  );
};
